module.exports = __webpack_public_path__ + "img/DSC_0059.1a9dd4ab.jpg";